import { Fragment, useState, useEffect, useRef } from "react"
import withStyles from "react-jss"
import axios from "axios"
import Parser from "html-react-parser"
import { RangeSlider } from "../index"
import {
  SCROLLY_TEXTBOX_INNER_PADDING,
  SCROLLY_TEXTBOX_OUTER_PADDING,
} from "../../data/globalStyles"
import { tsvJSON } from "../../utils/helper"
import { useAnimation, motion } from "framer-motion"
import { useInView } from "react-intersection-observer"

const squareVariants = {
  visible: { opacity: 1, transition: { duration: 1 } },
  hidden: { opacity: 0 },
}

const styles = {
  main: {
    position: "relative",
    width: "100%",
    display: "flex",
    maxWidth: "1140px",
    margin: "0 auto",
    padding: "15px 0",
    color: "#ffffff",
    boxSizing: "border-box",
    "@media only screen and (max-width: 840px)": {
      flexDirection: "column",
      padding: "0",
    },
    "@media only screen and (max-width: 310px)": {
      margin: "0 auto 3rem auto",
    },
  },
  right: {
    boxSizing: "border-box",
    position: "relative",
    width: "55%",
    margin: 0,
    // background: "grey",
    "@media only screen and (max-width: 840px)": {
      position: "relative",
      //bottom: "-57px",
      display: "flex",
      alignItems: "center",
      width: "100%",
      minWidth: "100%",
      maxWidth: "100%",
      height: "100vh",
    },
  },
  left: {
    boxSizing: "border-box",
    width: "45%",
    zIndex: 2,
    "@media only screen and (max-width: 840px)": {
      width: "100%",
      minWidth: "100%",
      maxWidth: "100%",
    },
    "& p": {
      fontFamily: "BreveText",
      fontSize: "19px",
    },
    ...SCROLLY_TEXTBOX_OUTER_PADDING,
  },
  text: {
    width: "100%",
    maxWidth: "460px",
    boxSizing: "border-box",
    fontFamily: "BreveText",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "19px",
    margin: "80vh auto",
    padding: SCROLLY_TEXTBOX_INNER_PADDING.padding,
    background: "#ffffff",
    borderRadius: "4px",
    color: "#000000",
    "@media only screen and (max-width: 840px)": {
      padding:
        SCROLLY_TEXTBOX_INNER_PADDING[
          "@media only screen and (max-width: 840px)"
        ].padding,
      margin: "10vh auto",
      // maxWidth: "fit-content",
    },
  },
  rightBox: {
    top: 0,
    width: "100%",
    height: "100vh",
    display: "flex",
    position: "sticky",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    paddingBottom: "50px",
    paddingTop: "20px",
    "@media (max-width: 780px)": {
      justifyContent: "start",
      position: "relative",
    },
    "& p": {
      fontFamily: "WiredMono",
      fontStyle: "normal",
      fontWeight: "400",
      fontSize: "14px",
      display: "flex",
      justifyContent: "space-between",
      textTransform: "uppercase",
      flexDirection: "column",
      margin: 0,
    },
  },
  rightBoxHeading: {
    borderBottom: "1px solid #ffffff",
    lineHeight: "60px",
    fontFamily: "WiredMono",
    fontStyle: "normal",
    fontWeight: "700",
    fontSize: "18px",
  },
  flexBox: {
    display: "flex",
    justifyContent: "space-around",
    margin: "15px 0px",
    "@media (max-width: 780px)": {
      margin: "10px 0px",
    },
  },
  ParaScore: {
    display: "flex",
    justifyContent: "space-between",
    borderTop: "1px solid #fff",
    lineHeight: "60px",
    flexDirection: "column",
  },
  slider: {
    textAlign: "center",
  },
  ParaScoreSpan: {
    fontFamily: "WiredMono",
    fontStyle: "normal",
    fontWeight: "700 !important",
    fontSize: "18px !important",
    display: "flex",
    flexDirection: "row !important",
    "& span": {
      margin: "8px 0px 0px 0px",
    },
  },
  ParaScoreInputs: {
    justifyContent: "center!important",
    color: "#ffffff",
    fontFamily: "WiredMono",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "12px",
    textAlign: "center",
  },
  rightBoxContent: {
    width: "80%",
  },
  ParaScoreSpanName: {
    display: "flex",
    flexDirection: "row",
  },
  ParaScoreSpanRank: {
    display: "flex",
    flexDirection: "column",
  },
  ParaScoreSpanScore: {
    display: "flex",
    flexDirection: "column",
  },
  ParaScoreSpanSmall: {
    fontFamily: "WiredMono",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "14px",
  },
  circle: {
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    background: "#00FF00",
    margin: "10px",
  },
}

const CaseCard = ({ classes, arcData, toggle = true, mainId }) => {
  const [load, setLoad] = useState(true)
  const articleRef = useRef([])
  const [stateData, setStateData] = useState(arcData.data[0])
  const [toggleData, setToggleData] = useState({
    age: 0,
    is_woman: 0,
    has_children: 0,
    language_requirement_completed: 0,
    missed_meeting: 0,
    addiction_problems: 0,
    shares_household_costs: 0,
    lacks_organizing_skills: 0,
  })
  const [sheetData, setSheetData] = useState([])
  const [compareData, setCompareData] = useState([])
  const controls = useAnimation()
  const [ref, inView] = useInView()
  useEffect(() => {
    if (inView) {
      controls.start("visible")
    }
  }, [controls, inView, stateData])

  async function getData() {
    const sheetRes = await axios.get(arcData.sheet)
    setSheetData(tsvJSON(sheetRes.data))
    let compData = []
    tsvJSON(sheetRes.data).forEach((item, i) => {
      if (item.is_default && item.is_default.includes("TRUE")) {
        if (parseInt(item.age) <= 35) {
          item.age = 0
        } else {
          item.age = 1
        }
        setToggleData(item)
        compData.push(item)
      }
    })
    setCompareData(compData)
    setLoad(false)
  }

  const toggleChange = (e, check) => {
    if (e.target.checked) {
      setToggleData({ ...toggleData, [e.target.name]: 1 })
    } else {
      setToggleData({ ...toggleData, [e.target.name]: 0 })
    }
  }

  useEffect(() => {
    let sheetArray = sheetData.find(
      (el) =>
        (parseInt(toggleData.age) === 0
          ? parseInt(el.age) <= 35
          : parseInt(el.age) >= 50) &&
        parseInt(el.is_woman) === parseInt(toggleData.is_woman) &&
        parseInt(el.has_children) === parseInt(toggleData.has_children) &&
        parseInt(el.language_requirement_completed) ===
          parseInt(toggleData.language_requirement_completed) &&
        parseInt(el.missed_meeting) === parseInt(toggleData.missed_meeting) &&
        parseInt(el.addiction_problems) ===
          parseInt(toggleData.addiction_problems) &&
        parseInt(el.shares_household_costs) ===
          parseInt(toggleData.shares_household_costs) &&
        parseInt(el.lacks_organizing_skills) ===
          parseInt(toggleData.lacks_organizing_skills)
    )
    sheetArray && setCompareData([sheetArray])
  }, [toggleData])

  useEffect(() => {
    getData()

    const items =
      (articleRef.current.children &&
        Array.from(articleRef.current.children).map((item, i) => {
          return item.children[0]
        })) ||
      []

    const detectIntersection = (entries) => {
      for (let e of entries) {
        let j = items.indexOf(e.target)
        if (e.isIntersecting) {
          setStateData(arcData.data[j])
        }
      }
    }

    const options = {
      threshold: 0.25,
    }

    const observer = new IntersectionObserver(detectIntersection, options)
    items.forEach((i) => {
      observer.observe(i)
    })
    return () => {
      items.forEach((i) => {
        observer.unobserve(i)
      })
    }
  }, [])

  const ariaMappings = {
    age: ["Under 35", "Over 50"],
    is_woman: ["Male", "Female"],
    has_children: ["Does not have children", "Has children"],
    language_requirement_completed: [
      "Did not meet language requirement",
      "Met language requirement",
    ],
    missed_meeting: ["Did not miss meeting", "Missed meeting"],
    addiction_problems: ["No addition problems", "Has addiction problems"],
    shares_household_costs: [
      "Does not share household costs",
      "Shares household costs",
    ],
    lacks_organizing_skills: [
      "Does not lack organizing skills",
      "Lacks organizing skills",
    ],
  }

  return (
    <section className={classes.main} id={mainId}>
      {(!load && (
        <>
          <article className={classes.left} ref={articleRef}>
            {arcData.data.map((row, r) => (
              <div key={r} className={classes.text}>
                {Parser(row.text)}
              </div>
            ))}
          </article>
          <figure className={classes.right}>
            <div className={classes.rightBox}>
              <div className={classes.rightBoxContent}>
                <h3 className={classes.rightBoxHeading}>CASE PROFILE </h3>
                {(Object.keys(stateData).length &&
                  stateData.checks.length &&
                  stateData.checks.map((check, c) => (
                    <motion.p
                      ref={ref}
                      animate={controls}
                      initial="hidden"
                      variants={squareVariants}
                      key={c}>
                      <span className={classes.flexBox}>
                        <span>{check.label}</span>
                        <span className="item" aria-hidden="true"></span>
                        {toggle ? (
                          <span style={{ color: check.color }}>
                            {check.toggle ? (
                              <label className="switch">
                                <input
                                  type="checkbox"
                                  defaultChecked={parseInt(
                                    toggleData[check.name]
                                  )}
                                  name={check.name}
                                  onChange={(e) => {
                                    toggleChange(e, check)
                                  }}
                                  aria-label={`Selected option - ${
                                    ariaMappings[check.name][
                                      toggleData[check.name]
                                    ]
                                  }`}
                                  aria-live="polite"
                                />
                                <span className="slider round"></span>
                              </label>
                            ) : (
                              (check.options &&
                                check.options.find(
                                  (e) =>
                                    parseInt(e.val) === parseInt(check.value)
                                ).label) ||
                              check.value
                            )}
                          </span>
                        ) : (
                          <span>
                            {(check.options &&
                              check.options.find(
                                (e) => parseInt(e.val) === parseInt(check.value)
                              ).label) ||
                              check.value}
                          </span>
                        )}
                      </span>
                    </motion.p>
                  ))) || <></>}
              </div>
              {(compareData &&
                compareData.length &&
                Object.keys(stateData).length &&
                stateData.compare &&
                stateData.compare.length && (
                  <motion.div
                    ref={ref}
                    animate={controls}
                    initial="hidden"
                    variants={squareVariants}
                    style={{ width: "80%" }}>
                    <div
                      className={classes.ParaScore + " boxRightContentPara"}
                      aria-live="polite"
                      aria-atomic="true">
                      {stateData.compare.map((user, u) => (
                        <Fragment key={u}>
                          <p
                            className={classes.ParaScoreSpan}
                            style={{
                              color:
                                parseInt(compareData[u].list_place) > 27000
                                  ? "rgb(255, 0, 0)"
                                  : "rgb(255, 255, 255)",
                            }}>
                            <span>Score</span>
                            <span>
                              {parseFloat(compareData[u].score * 100).toFixed(
                                1
                              )}
                            </span>
                          </p>
                          <p
                            className={classes.ParaScoreSpan}
                            style={{
                              color:
                                parseInt(compareData[u].list_place) > 27000
                                  ? "rgb(255, 0, 0)"
                                  : "rgb(255, 255, 255)",
                            }}>
                            <span>risk ranking</span>
                            <span>
                              {parseInt(
                                compareData[u].list_place
                              ).toLocaleString("en-US")}
                            </span>
                          </p>
                        </Fragment>
                      ))}
                    </div>
                    <div className={classes.slider}>
                      {" "}
                      <RangeSlider rankValue={compareData[0].list_place} />
                      <p>Fraud investigation gauge</p>
                    </div>
                  </motion.div>
                )) || <></>}
            </div>
          </figure>{" "}
        </>
      )) || (
        <div className="loadBox">
          <div className="loader"></div>
        </div>
      )}
    </section>
  )
}

export default withStyles(styles)(CaseCard)
